import React from 'react';

import { Field } from 'formik';

import Avatar, { AvatarProps } from '@common/react/components/Forms/Avatar';

interface Props extends Omit<AvatarProps, 'object'> {
	fieldName?: string;
	object?: AvatarProps['object'];
}

const FormAvatar: React.FC<Props> = (props) => {
	const {
		fieldName,
		...avatarProps
	} = props;
	return <Field name={fieldName}>
		{({ form }) => <Avatar
			update={(value) => {
				form.setValues({ ...form.values, ...value });
			}}
			object={form.values}
			infoMessage=""
			buttonCaption="Upload Photo"
			{...avatarProps}
		/>}
	</Field>;
};

export default FormAvatar;
